import { TRANSITIONS, TransitionType } from 'enums'

export const isCrossingTransition = (type: TransitionType) => {
  if (!type) return false
  switch (type) {
    case TRANSITIONS.FADEIN:
    case TRANSITIONS.FADEOUT:
      return false
    default:
      return true
  }
}
